// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__-7aAW","col":"styles_col__2kaMV"};